export default class LocationGroupModel {
  constructor(data) {
    const { id, name, status, published } = data
    this.id = id
    this.name = name
    this.status = status
    this.published = published
  }

  get isActive() {
    return this.status === 'active'
  }

  static assign(data) {
    return new LocationGroupModel(data)
  }
}
